var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import { matches } from '@js/modules/utilities';
/**
 * Dynamically loads scripts based on what elements are present in the DOM.
 *
 * This eliminates the need for different webpack entrypoints, as modules are
 * only (async) loaded when there are elements present that require that module.
 *
 * Since scripts are cached, this basically means that all our JS is loaded
 * progressively when needed and resolves immediately on subsequent requests.
 */
window.addEventListener('DOMContentLoaded', function () {
    require('@js/polyfills');
    loadScripts();
    loadApps();
});
/**
 * Loads modules.
 */
export var loadScripts = function () {
    // Modules loaded on virtually every page.
    loadAnalyticsModule();
    loadNavigationModule();
    loadErrorHandlerModule();
    loadFormValidationModule();
    // Modules loaded sporadically.
    loadToggleModule();
    loadTableModule();
    loadSliderModule();
    loadButtonModule();
    loadSuperButtonModule();
    loadLineitemModule();
    loadAutoSubmitModule();
    loadShippingAndBillingModule();
    loadGoogleAutocompleteModule();
    loadPaymentOptionsModule();
    loadPaymentButtonsModule();
    loadProofsModule();
    loadFilterModule();
    loadWxCheckoutModule();
    loadCharacterCountModule();
    loadFormSubmitModule();
    loadHotwiredTurboModule();
    // Apps to be remounted on subsequent turbo page loads
    document.documentElement.addEventListener('turbo:load', function () {
        loadToggleModule();
        loadFilterModule();
    });
};
/**
 * Loads Vue apps.
 */
export var loadApps = function () {
    loadClipboardApp();
    loadRegionSwitcherApp();
    loadLoginApp();
    loadInspirationApp();
    loadGiftcardApp();
    loadReviewsApp();
    loadBuilderApp();
    loadProofReviewApp();
    loadProofReview3dApp();
    loadLazyLoaderApp();
    loadTypeaheadApp();
    loadInterstitialApp();
    loadArtDetailApp();
    // Apps to be remounted on subsequent turbo page loads
    document.documentElement.addEventListener('turbo:load', function () {
        loadLazyLoaderApp();
        loadTypeaheadApp();
        loadInterstitialApp();
        loadBuilderApp();
    });
};
/**
 * Loads the Google Analytics module.
 *
 * We obfuscate this chunkname in order to not trip up overzealous ad blockers.
 */
var loadAnalyticsModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var Analytics;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, import(/* webpackChunkName: 'global' */ '@js/modules/Analytics')];
            case 1:
                Analytics = (_a.sent()).default;
                new Analytics();
                return [2 /*return*/];
        }
    });
}); };
/**
 * Loads the Navigation module.
 */
var loadNavigationModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var Navigation;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, import(/* webpackChunkName: 'global' */ '@js/modules/Navigation')];
            case 1:
                Navigation = (_a.sent()).default;
                new Navigation();
                return [2 /*return*/];
        }
    });
}); };
/**
 * Loads the ErrorHandler module.
 */
var loadErrorHandlerModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var ErrorHandler;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, import(/* webpackChunkName: 'global' */ '@js/modules/ErrorHandler')];
            case 1:
                ErrorHandler = (_a.sent()).default;
                new ErrorHandler();
                return [2 /*return*/];
        }
    });
}); };
/**
 * Loads the FormValidation module.
 */
var loadFormValidationModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var FormValidation;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, import(/* webpackChunkName: 'global' */ '@js/modules/FormValidation')];
            case 1:
                FormValidation = (_a.sent()).default;
                new FormValidation();
                return [2 /*return*/];
        }
    });
}); };
/**
 * Finds elements with the data-module-toggle attribute and attaches the Toggle
 * module to them.
 */
var loadToggleModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-module-toggle]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var Toggle;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'Toggle' */ '@js/modules/Toggle')];
                    case 1:
                        Toggle = (_a.sent()).default;
                        new Toggle(element);
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-module-filter attribute and attaches the Filter
 * module to them.
 */
var loadFilterModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-module-filter]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var Filter, customPathAttribute, customPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'Filter' */ '@js/modules/Filter')];
                    case 1:
                        Filter = (_a.sent()).default;
                        customPathAttribute = element.getAttribute('data-custom-path');
                        customPath = customPathAttribute ? customPathAttribute : '';
                        new Filter(element, customPath);
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-module-table attribute and attaches the Table
 * module to them.
 */
var loadTableModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-module-table]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var Table;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'Table' */ '@js/modules/Table')];
                    case 1:
                        Table = (_a.sent()).default;
                        new Table(element);
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-module-slider attribute and attaches the Slider
 * module to them.
 */
var loadSliderModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-module-slider]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var Slider;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'Slider' */ '@js/modules/Slider')];
                    case 1:
                        Slider = (_a.sent()).default;
                        new Slider(element);
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-module-loading-button attribute and attaches the
 * Button module to them.
 */
var loadButtonModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-module-loading-button]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var Button;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'Button' */ '@js/modules/Button')];
                    case 1:
                        Button = (_a.sent()).default;
                        new Button(element);
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-module-lineitem attribute and attaches the
 * Lineitem module to them.
 */
var loadLineitemModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-module-lineitem]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var Lineitem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'Lineitem' */ '@js/modules/Lineitem')];
                    case 1:
                        Lineitem = (_a.sent()).default;
                        new Lineitem(element);
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-module-lineitem attribute and attaches the
 * Lineitem module to them.
 */
var loadSuperButtonModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-module-superbutton]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var SuperButton;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'SuperButton' */ '@js/modules/SuperButton')];
                    case 1:
                        SuperButton = (_a.sent()).default;
                        new SuperButton(element);
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-module-auto-submit attribute and attaches the
 * AutoSubmit module to them.
 */
var loadAutoSubmitModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-module-auto-submit]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var AutoSubmit, option, options;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'AutoSubmit' */ '@js/modules/AutoSubmit')];
                    case 1:
                        AutoSubmit = (_a.sent()).default;
                        option = element.getAttribute('[data-module-auto-submit]') || 'change';
                        options = {
                            event: option,
                        };
                        new AutoSubmit(element, options);
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-module-shipping-and-billing attribute and loads
 * the ShippingAndBilling module.
 */
var loadShippingAndBillingModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var element, ShippingAndBilling;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                element = document.querySelector('[data-module-shipping-and-billing]');
                if (!element) return [3 /*break*/, 2];
                return [4 /*yield*/, import(/* webpackChunkName: 'ShippingAndBilling' */ '@js/modules/ShippingAndBilling')];
            case 1:
                ShippingAndBilling = (_a.sent()).default;
                new ShippingAndBilling();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
/**
 * Finds elements with the data-module-google-autocomplete attribute and loads
 * the GoogleAutocomplete module.
 */
var loadGoogleAutocompleteModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-module-google-autocomplete]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var GoogleAutocomplete, selector;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'GoogleAutocomplete' */ '@js/modules/GoogleAutocomplete')];
                    case 1:
                        GoogleAutocomplete = (_a.sent()).default;
                        selector = element.getAttribute('data-module-google-autocomplete') || 'shipping';
                        new GoogleAutocomplete(element, selector);
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-module-payment-options attribute and loads the
 * PaymentOptions module.
 */
var loadPaymentOptionsModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var element, PaymentOptions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                element = document.querySelector('[data-module-payment-options]');
                if (!element) return [3 /*break*/, 2];
                return [4 /*yield*/, import(/* webpackChunkName: 'PaymentOptions' */ '@js/modules/PaymentOptions')];
            case 1:
                PaymentOptions = (_a.sent()).default;
                new PaymentOptions();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
/**
 * Finds elements with the data-module-payment-buttons attribute and loads the
 * PaymentButtons module.
 */
var loadPaymentButtonsModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var element, PaymentButtons;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                element = document.querySelector('[data-module-payment-buttons]');
                if (!element) return [3 /*break*/, 2];
                return [4 /*yield*/, import(/* webpackChunkName: 'PaymentButtons' */ '@js/modules/PaymentButtons')];
            case 1:
                PaymentButtons = (_a.sent()).default;
                new PaymentButtons();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
/**
 * Finds elements with the data-module-proofs attribute and loads the Proofs
 * module.
 */
var loadProofsModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var element, Proofs;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                element = document.querySelector('[data-module-proofs]');
                if (!element) return [3 /*break*/, 2];
                return [4 /*yield*/, import(/* webpackChunkName: 'Proofs' */ '@js/modules/Proofs')];
            case 1:
                Proofs = (_a.sent()).default;
                new Proofs();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
/**
 * Finds elements with the data-module-wx-checkout attribute and loads the
 * WxCheckout module.
 */
var loadWxCheckoutModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var element, WxCheckout;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                element = document.querySelector('[data-module-wx-checkout]');
                if (!element) return [3 /*break*/, 2];
                return [4 /*yield*/, import(/* webpackChunkName: 'WxCheckout' */ '@js/modules/WxCheckout')];
            case 1:
                WxCheckout = (_a.sent()).default;
                new WxCheckout();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
/**
 * Finds elements with the data-module-character-count attribute and attaches the
 * CharacterCount module to them.
 */
var loadCharacterCountModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-module-charactercount]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var CharacterCount, option, options;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'CharacterCount' */ '@js/modules/CharacterCount')];
                    case 1:
                        CharacterCount = (_a.sent()).default;
                        option = element.getAttribute('[data-module-charactercount]') || 'change';
                        options = {
                            event: option,
                        };
                        new CharacterCount(element);
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds forms with the data-module-form-submit and overrides the form submit.
 * Turning it into an axios request.
 */
var loadFormSubmitModule = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-module-form-submit]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var FormSubmit, option, options;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'FormSubmit' */ '@js/modules/FormSubmit')];
                    case 1:
                        FormSubmit = (_a.sent()).default;
                        option = element.getAttribute('[data-module-form-submit]') || 'change';
                        options = {
                            event: option,
                        };
                        new FormSubmit(element);
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-module-hotwired-turbo attribute and imports the
 * hotwiredTurbo module into the page
 */
var loadHotwiredTurboModule = function (renewed) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        document.addEventListener('click', function (event) {
            var target = event.target;
            var match = matches(target, '[data-turbo-trigger]');
            if (match) {
                event.preventDefault();
                // Only load when a hotwired component is triggered via mouseEvent
                import(/* webpackChunkName: 'hotwiredTurbo' */ '@hotwired/turbo').then(function (turbo) { return __awaiter(void 0, void 0, void 0, function () {
                    var anchor, scrollTo_1;
                    return __generator(this, function (_a) {
                        anchor = target.closest('a');
                        if (anchor) {
                            turbo.visit(anchor.href);
                            scrollTo_1 = function () {
                                var scrollAnchor = document.getElementById('turboScrollAnchor');
                                if (scrollAnchor) {
                                    var header = document.getElementById('header');
                                    if (header) {
                                        var topOffset = header.offsetHeight; // account for fixed cp header
                                        window.scroll({
                                            top: scrollAnchor.offsetTop - topOffset,
                                        });
                                    }
                                }
                                document.removeEventListener('turbo:render', scrollTo_1);
                            };
                            document.addEventListener('turbo:render', scrollTo_1);
                        }
                        return [2 /*return*/];
                    });
                }); });
            }
        });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-app-clipboard attribute and attaches the
 * Clipboard Vue app to them.
 */
var loadClipboardApp = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-app-clipboard]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var Vue, classes, props;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'vue' */ 'vue')];
                    case 1:
                        Vue = (_a.sent()).default;
                        classes = element.getAttribute('class');
                        props = JSON.parse(element.getAttribute('data-app-props'));
                        new Vue({
                            el: element,
                            components: {
                                'clipboardCopy': function () { return import(/* webpackChunkName: "ClipboardCopy" */ '@vuedir/components/ClipboardCopy'); },
                            },
                            render: function (createElement) {
                                return createElement('clipboardCopy', {
                                    attrs: {
                                        class: classes,
                                    },
                                    props: props,
                                });
                            },
                        });
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-app-region-switcher attribute and attaches the
 * RegionSwitcher Vue app to them.
 */
var loadRegionSwitcherApp = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-app-region-switcher]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var Vue, classes, props;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'vue' */ 'vue')];
                    case 1:
                        Vue = (_a.sent()).default;
                        classes = element.getAttribute('class');
                        props = JSON.parse(element.getAttribute('data-app-props'));
                        new Vue({
                            el: element,
                            components: {
                                'regionSwitcher': function () { return import(/* webpackChunkName: "RegionSwitcher" */ '@vuedir/components/RegionSwitcher'); },
                            },
                            render: function (createElement) {
                                return createElement('regionSwitcher', {
                                    attrs: {
                                        class: classes,
                                    },
                                    props: props,
                                });
                            },
                        });
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-app-interstitial attribute and attaches the
 * Interstitial Vue app to them.
 */
var loadInterstitialApp = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-app-interstitial]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var Vue, classes, props, originalElement;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'vue' */ 'vue')];
                    case 1:
                        Vue = (_a.sent()).default;
                        classes = element.getAttribute('class');
                        props = JSON.parse(element.getAttribute('data-app-props'));
                        new Vue({
                            el: element,
                            components: {
                                'interstitial': function () { return import(/* webpackChunkName: "Interstitial" */ '@vuedir/components/Interstitial'); },
                            },
                            beforeMount: function () {
                                // Save the original mounting element
                                originalElement = this.$el.outerHTML;
                                // Destroy the vue app before the page is cached on turbo page leave
                                document.addEventListener('turbo:before-cache', destroyVueApp.bind(this));
                            },
                            destroyed: function () {
                                // Reinstate original mounting element
                                this.$el.outerHTML = originalElement;
                            },
                            render: function (createElement) {
                                return createElement('interstitial', {
                                    attrs: {
                                        class: classes,
                                    },
                                    props: props,
                                });
                            },
                        });
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
var loadTypeaheadApp = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-app-autosuggest]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var Vue, classes, props;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'vue' */ 'vue')];
                    case 1:
                        Vue = (_a.sent()).default;
                        classes = element.getAttribute('class');
                        props = JSON.parse(element.getAttribute('data-app-props'));
                        new Vue({
                            el: element,
                            components: {
                                'autoSuggest': function () { return import(/* webpackChunkName: "Autosuggest" */ '@vuedir/components/Autosuggest'); },
                            },
                            render: function (createElement) {
                                return createElement('autoSuggest', {
                                    attrs: {
                                    //class: classes,
                                    },
                                    props: props,
                                });
                            },
                        });
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-app-lazy-image attribute and attaches the
 * Lazy Image Vue app to them.
 */
var loadLazyLoaderApp = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-app-lazy-image]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var Vue, classes, props, originalElement;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'vue' */ 'vue')];
                    case 1:
                        Vue = (_a.sent()).default;
                        classes = element.getAttribute('class');
                        props = JSON.parse(element.getAttribute('data-app-props'));
                        new Vue({
                            el: element,
                            components: {
                                'lazyImage': function () { return import(/* webpackChunkName: "LazyImage" */ '@vuedir/components/LazyImage'); },
                            },
                            beforeMount: function () {
                                // Save the original mounting element
                                originalElement = this.$el.outerHTML;
                                // Destroy the vue app before the page is cached on turbo page leave
                                document.addEventListener('turbo:before-cache', destroyVueApp.bind(this));
                            },
                            destroyed: function () {
                                // Reinstate original mounting element
                                this.$el.outerHTML = originalElement;
                            },
                            render: function (createElement) {
                                return createElement('lazyImage', {
                                    attrs: {
                                        class: classes,
                                    },
                                    props: props,
                                });
                            },
                        });
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-app-login attribute and attaches the Login Vue app
 * to them.
 */
var loadLoginApp = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-app-login]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var Vue, classes, props;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'vue' */ 'vue')];
                    case 1:
                        Vue = (_a.sent()).default;
                        classes = element.getAttribute('class');
                        props = JSON.parse(element.getAttribute('data-app-props'));
                        new Vue({
                            el: element,
                            components: {
                                'Login': function () { return import(/* webpackChunkName: "Login" */ '@vuedir/components/Login'); },
                            },
                            render: function (createElement) {
                                return createElement('Login', {
                                    attrs: {
                                        class: classes,
                                    },
                                    props: props,
                                });
                            },
                        });
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-app-inspiration attribute and attaches the
 * Inspiration Vue app to them.
 */
var loadInspirationApp = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-app-inspiration]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var observeApp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'utilities' */ '@js/modules/utilities')];
                    case 1:
                        observeApp = (_a.sent()).observeApp;
                        observeApp(element, {}, function () { return __awaiter(void 0, void 0, void 0, function () {
                            var Vue, classes, props;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'vue' */ 'vue')];
                                    case 1:
                                        Vue = (_a.sent()).default;
                                        classes = element.getAttribute('class');
                                        props = JSON.parse(element.getAttribute('data-app-props'));
                                        new Vue({
                                            el: element,
                                            components: {
                                                'inspiration': function () { return import(/* webpackChunkName: "Inspiration" */ '@vuedir/components/Inspiration'); },
                                            },
                                            render: function (createElement) {
                                                return createElement('inspiration', {
                                                    attrs: {
                                                        class: classes,
                                                    },
                                                    props: props,
                                                });
                                            },
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-app-giftcard attribute and attaches the Giftcard
 * Vue app to them.
 */
var loadGiftcardApp = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-app-giftcard]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var observeApp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'utilities' */ '@js/modules/utilities')];
                    case 1:
                        observeApp = (_a.sent()).observeApp;
                        observeApp(element, {}, function () { return __awaiter(void 0, void 0, void 0, function () {
                            var vuePromise, localesPromise, currencyFilterPromise, Vue, locales, CurrencyFilter, classes, props, locale, currencyCode, localeUs, currencyCodeUs, currencyFilter, currencyFilterUs;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        vuePromise = import(/* webpackChunkName: 'vue' */ 'vue');
                                        localesPromise = import(/* webpackChunkName: 'locales' */ '@vuedir/constants/locales');
                                        currencyFilterPromise = import(/* webpackChunkName: 'CurrencyFilter' */ '@vuedir/filters/Currency');
                                        return [4 /*yield*/, vuePromise];
                                    case 1:
                                        Vue = (_a.sent()).default;
                                        return [4 /*yield*/, localesPromise];
                                    case 2:
                                        locales = _a.sent();
                                        return [4 /*yield*/, currencyFilterPromise];
                                    case 3:
                                        CurrencyFilter = (_a.sent()).default;
                                        classes = element.getAttribute('class');
                                        props = JSON.parse(element.getAttribute('data-app-props'));
                                        locale = props.locale || locales.LOCALE_DEFAULT;
                                        currencyCode = props.currencyCode || locales.CURRENCY_CODE_DEFAULT;
                                        localeUs = locales.LOCALE_DEFAULT;
                                        currencyCodeUs = locales.CURRENCY_CODE_DEFAULT;
                                        currencyFilter = new CurrencyFilter(locale, currencyCode);
                                        currencyFilterUs = new CurrencyFilter(localeUs, currencyCodeUs);
                                        Vue.filter('currencyUs', function (value) { return currencyFilterUs.format(value); });
                                        Vue.filter('currency', function (value) { return currencyFilter.format(value); });
                                        new Vue({
                                            el: element,
                                            components: {
                                                'giftcard': function () { return import(/* webpackChunkName: "Giftcard" */ '@vuedir/components/Giftcard'); },
                                            },
                                            render: function (createElement) {
                                                return createElement('giftcard', {
                                                    attrs: {
                                                        class: classes,
                                                    },
                                                    props: props,
                                                });
                                            },
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-app-reviews attribute and attaches the Reviews
 * Vue app to them.
 */
var loadReviewsApp = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-app-reviews]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var Vue, classes, props;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'vue' */ 'vue')];
                    case 1:
                        Vue = (_a.sent()).default;
                        classes = element.getAttribute('class');
                        props = JSON.parse(element.getAttribute('data-app-props'));
                        new Vue({
                            el: element,
                            components: {
                                'reviews': function () { return import(/* webpackChunkName: "Reviews" */ '@vuedir/components/Reviews'); },
                            },
                            render: function (createElement) {
                                return createElement('reviews', {
                                    attrs: {
                                        class: classes,
                                    },
                                    props: props,
                                });
                            },
                        });
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-app-builder attribute and attaches the Builder
 * Vue app to them.
 */
var loadBuilderApp = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-app-builder]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var vuePromise, vuexPromise, vueRouterPromise, currencyFilterPromise, localesPromise, routesPromise, modulesPromise, Vue, Vuex, VueRouter, CurrencyFilter, locales, routes, modules, routerRoutes, router, store, props, locale, currencyCode, currencyFilter, originalElement, triggerBuilderRoute;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        vuePromise = import(/* webpackChunkName: 'vue' */ 'vue');
                        vuexPromise = import(/* webpackChunkName: 'vuex' */ 'vuex');
                        vueRouterPromise = import(/* webpackChunkName: 'vue-router' */ 'vue-router');
                        currencyFilterPromise = import(/* webpackChunkName: 'CurrencyFilter' */ '@vuedir/filters/Currency');
                        localesPromise = import(/* webpackChunkName: 'locales' */ '@vuedir/constants/locales');
                        routesPromise = import(/* webpackChunkName: 'routes' */ '@vuedir/constants/routes');
                        modulesPromise = import(/* webpackChunkName: 'modules' */ '@vuedir/store');
                        return [4 /*yield*/, vuePromise];
                    case 1:
                        Vue = (_a.sent()).default;
                        return [4 /*yield*/, vuexPromise];
                    case 2:
                        Vuex = (_a.sent()).default;
                        return [4 /*yield*/, vueRouterPromise];
                    case 3:
                        VueRouter = (_a.sent()).default;
                        return [4 /*yield*/, currencyFilterPromise];
                    case 4:
                        CurrencyFilter = (_a.sent()).default;
                        return [4 /*yield*/, localesPromise];
                    case 5:
                        locales = _a.sent();
                        return [4 /*yield*/, routesPromise];
                    case 6:
                        routes = _a.sent();
                        return [4 /*yield*/, modulesPromise];
                    case 7:
                        modules = _a.sent();
                        Vue.use(Vuex);
                        Vue.use(VueRouter);
                        routerRoutes = [
                            {
                                path: '/',
                                component: function () { return import('@vuedir/components/App'); },
                                children: [
                                    { path: 'create', name: routes.ROUTE_CREATE, component: function () { return import('@vuedir/components/Builder'); } },
                                    { path: 'modify/:id', name: routes.ROUTE_MODIFY, component: function () { return import('@vuedir/components/Builder'); } },
                                ],
                            },
                        ];
                        router = new VueRouter({
                            mode: 'history',
                            base: element.getAttribute('data-app-builder'),
                            routes: routerRoutes,
                        });
                        store = new Vuex.Store({ modules: modules });
                        props = JSON.parse(element.getAttribute('data-app-props'));
                        locale = props.locale || locales.LOCALE_DEFAULT;
                        currencyCode = props.currencyCode || locales.CURRENCY_CODE_DEFAULT;
                        currencyFilter = new CurrencyFilter(locale, currencyCode);
                        Vue.filter('currency', function (value) { return currencyFilter.format(value); });
                        triggerBuilderRoute = function (event) {
                            var target = event.target;
                            var match = matches(target, '[data-app-launch-builder]');
                            if (match) {
                                var href = match.getAttribute('href');
                                // support the use of valid urls
                                if (href.startsWith('/art')) {
                                    href = href.replace('/art', '');
                                }
                                event.preventDefault();
                                router.push(href);
                            }
                        };
                        new Vue({
                            el: element,
                            router: router,
                            store: store,
                            beforeMount: function () {
                                // Save the original mounting element
                                originalElement = this.$el.outerHTML;
                                // Destroy the vue app before the page is cached on turbo page leave
                                document.addEventListener('turbo:before-cache', destroyVueApp.bind(this));
                            },
                            mounted: function () {
                                // Make it possible for regular buttons to trigger the router.
                                document.addEventListener('click', triggerBuilderRoute);
                            },
                            destroyed: function () {
                                // Reinstate the original mounting element
                                this.$el.outerHTML = originalElement;
                                // Remove obsolete event listener
                                document.removeEventListener('click', triggerBuilderRoute);
                            },
                            render: function (createElement) {
                                return createElement('router-view', { props: props });
                            },
                        });
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-app-builder attribute and attaches the Builder
 * Vue app to them.
 */
var loadProofReviewApp = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-app-proof-review]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var Vue, classes, props;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'vue' */ 'vue')];
                    case 1:
                        Vue = (_a.sent()).default;
                        classes = element.getAttribute('class');
                        props = JSON.parse(element.getAttribute('data-app-props'));
                        props.orderProofs = Object.values(props.orderProofs);
                        props.orderProofs.forEach(function (proof) {
                            if (proof.notes) {
                                proof.notes = Object.values(proof.notes);
                            }
                        });
                        new Vue({
                            el: element,
                            components: {
                                'proofReview': function () { return import(/* webpackChunkName: "ProofReview" */ '@vuedir/components/ProofReview'); },
                            },
                            render: function (createElement) {
                                return createElement('proofReview', {
                                    attrs: {
                                        class: classes,
                                    },
                                    props: props,
                                });
                            },
                        });
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-app-proof-review-3d attribute and attaches the ProofReview3d
 * Vue app to them.
 */
var loadProofReview3dApp = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements, vuexPromise, modulesPromise;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-app-proof-review-3d]');
        vuexPromise = import(/* webpackChunkName: 'vuex' */ 'vuex');
        modulesPromise = import(/* webpackChunkName: 'modules' */ '@vuedir/store');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var Vue, classes, props, modules, Vuex, store;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'vue' */ 'vue')];
                    case 1:
                        Vue = (_a.sent()).default;
                        classes = element.getAttribute('class');
                        props = JSON.parse(element.getAttribute('data-app-props'));
                        return [4 /*yield*/, modulesPromise];
                    case 2:
                        modules = _a.sent();
                        return [4 /*yield*/, vuexPromise];
                    case 3:
                        Vuex = (_a.sent()).default;
                        props.orderProofs = Object.values(props.orderProofs);
                        props.orderProofs.forEach(function (proof) {
                            if (proof.notes) {
                                proof.notes = Object.values(proof.notes);
                            }
                        });
                        Vue.use(Vuex);
                        store = new Vuex.Store({ modules: modules });
                        new Vue({
                            el: element,
                            components: {
                                'proofReview3d': function () { return import(/* webpackChunkName: "ProofReview3d" */ '@vuedir/components/ProofReview3d'); },
                            },
                            store: store,
                            render: function (createElement) {
                                return createElement('proofReview3d', {
                                    attrs: {
                                        class: classes,
                                    },
                                    props: props,
                                });
                            },
                        });
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
/**
 * Finds elements with the data-app-art-detail attribute and attaches the
 * RegionSwitcher Vue app to them.
 */
var loadArtDetailApp = function () { return __awaiter(void 0, void 0, void 0, function () {
    var elements;
    return __generator(this, function (_a) {
        elements = document.querySelectorAll('[data-app-art-detail]');
        elements.forEach(function (element) { return __awaiter(void 0, void 0, void 0, function () {
            var Vue, classes, props;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import(/* webpackChunkName: 'vue' */ 'vue')];
                    case 1:
                        Vue = (_a.sent()).default;
                        classes = element.getAttribute('class');
                        props = JSON.parse(element.getAttribute('data-app-props'));
                        new Vue({
                            el: element,
                            components: {
                                'artDetail': function () { return import(/* webpackChunkName: "ArtDetail" */ '@vuedir/components/ArtDetail'); },
                            },
                            render: function (createElement) {
                                return createElement('artDetail', {
                                    attrs: {
                                        class: classes,
                                    },
                                    props: props,
                                });
                            },
                        });
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
// A global function that will destroy the vue app and remove the turbo
// event listener that calls it.
function destroyVueApp() {
    this.$destroy();
    document.removeEventListener('turbo:before-cache', destroyVueApp);
}
